import { registerComponent } from '@gig/magic-common';
import NotificationsComponent from './notifications.vue.js';

var Notifications = registerComponent(NotificationsComponent);

export { Notifications };
